module.exports = __webpack_public_path__ + "static/img/ios_button.08a3fac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/appDownLoad/pc/ios_button.png
// module id = iIFT
// module chunks = 1